import Dialog from './global/Dialog'
import Navigation from './global/Navigation'
import Progress from './global/Progress'
import Snackbar from './global/Snackbar'

import Changes from './repository/Changes'
import AddFileDialog from './repository/AddFileDialog'
import Files from './repository/Files'
import Folders from './repository/Folders'

import Avatar from './user/Avatar'
import UserCard from './user/UserCard'

import GroupCard from './group/GroupCard'

import Event from './schedule/Event'

export default [
  { component: Dialog, tag: 'pi-dialog' },
  { component: Navigation, tag: 'pi-navigation' },
  { component: Progress, tag: 'pi-progress' },
  { component: Snackbar, tag: 'pi-snackbar' },

  { component: Changes, tag: 'pi-changes' },
  { component: AddFileDialog, tag: 'pi-addfiledialog' },
  { component: Files, tag: 'pi-files' },
  { component: Folders, tag: 'pi-folders' },
  
  { component: Avatar, tag: 'pi-avatar' },
  { component: UserCard, tag: 'pi-usercard' },
  
  { component: GroupCard, tag: 'pi-groupcard' },
  
  { component: Event, tag: 'pi-event' },
]